import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ProfessionnelItem } from "src/app/professionnel/core/model/professionnel-item";
import { TypeCredit } from "src/app/parametrage/core/model/type-credit";
import { Produit } from "src/app/parametrage/core/model/produit";
import { ProfessionnelItemService } from "src/app/professionnel/core/service/professionnel-item.service";
import { TypeCreditService } from "src/app/parametrage/core/service/type-credit.service";
import { ProduitService } from "src/app/parametrage/core/service/produit.service";

@Component({
  selector: "app-edit-credit-modal",
  templateUrl: "./edit-credit-modal.component.html",
  styleUrls: ["./edit-credit-modal.component.scss"],
})
export class EditCreditModalComponent implements OnInit {
  @Input() professionnelItemId;
  @Input() workflowCode;

  requestId: number;

  professionnelItem: ProfessionnelItem;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  typeCreditLabel: string = "";

  typeCredits: TypeCredit[];
  produits: Produit[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _professionnelItemService: ProfessionnelItemService,
    private _typeCreditService: TypeCreditService,
    private _produitService: ProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      typeCredit: [null, Validators.compose([Validators.required])],
      produit: [null, Validators.compose([Validators.required])],

      montant: [null, Validators.compose([Validators.required])],
      taux: [null, Validators.compose([Validators.required])],
      echeance: [null, Validators.compose([Validators.required])],
      montantAccorde: [null, Validators.compose([Validators.required])],
      tauxAccorde: [null, Validators.compose([Validators.required])],
      payeurFinal: [null, Validators.compose([Validators.nullValidator])],
      echeanceAccorde: [null, Validators.compose([Validators.required])],
      commissionEngagementAccorde: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      dureeTirage: [null, Validators.compose([Validators.nullValidator])],
      tauxEscompte: [null, Validators.compose([Validators.nullValidator])],
      commissionStructuration: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      fraisDossier: [null, Validators.compose([Validators.nullValidator])],
      commissionOperationCredit: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      objetFinancement: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(21843),
        ],
      ],
    });
  }

  ngOnInit() {
    this.getProfessionnelItemById(this.professionnelItemId);
    this.getListTypeCredit();
  }

  getProfessionnelItemById(professionnelItemId) {
    this._professionnelItemService
      .getProfessionnelItemById(professionnelItemId)
      .subscribe(
        (data) => {
          this.professionnelItem = data;
          this.typeCreditLabel =
            this.professionnelItem.produit.typeCredit.label;

          this.getListproduitByTypeCredit(
            this.professionnelItem.produit.typeCredit.id
          );

          if (this.professionnelItem.montantAccorde == null) {
            this.professionnelItem.montantAccorde =
              this.professionnelItem.montant;
          }

          if (this.professionnelItem.tauxAccorde == null) {
            this.professionnelItem.tauxAccorde = this.professionnelItem.taux;
          }

          if (this.professionnelItem.echeanceAccorde == null) {
            this.professionnelItem.echeanceAccorde =
              this.professionnelItem.echeance;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getListTypeCredit() {
    this._typeCreditService
      .getListTypeCreditByWorkflow(this.workflowCode)
      .subscribe(
        (data) => {
          this.typeCredits = data.sort((a, b) => (a.label > b.label ? 1 : -1));
        },
        (error) => {
          console.log(error);
        }
      );
  }

  changeProduits() {
    let typeCreditId = this.form2.controls["typeCredit"].value;
    this.getListproduitByTypeCredit(typeCreditId);
  }

  getListproduitByTypeCredit(typeCreditId) {
    this._produitService.getListproduitByTypeCredit(typeCreditId).subscribe(
      (data) => {
        this.produits = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  update(): void {
    this.spinner.show();
    this._professionnelItemService
      .putProfessionnelItem(this.professionnelItem)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
